import { LoadablePaint } from '@confluence/loadable';

export const MainLayout = LoadablePaint({
	_reactTreeRootForServerPlaceholderId: true,
	name: 'MainLayout',
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-MainLayout" */ './MainLayout')).MainLayout,
});
